mutation NoteDocumentPoolCreate($input: NoteDocumentPoolCreateInput!) {
  noteDocumentPoolCreate(input: $input) {
    note {
      id
    }
  }
}
